import { CompanyProfileTab } from '@/components/misc/CompanyProfile/types'

export const COMPANY_PROFILE_TAB: Record<CompanyProfileTab, CompanyProfileTab> =
  {
    overview: 'overview',
    servicesAndExpertise: 'servicesAndExpertise',
    reviews: 'reviews',
    team: 'team',
    monitoring: 'monitoring',
    commercialAgreements: 'commercialAgreements',
    calendarLinks: 'calendarLinks',
    yourComments: 'yourComments',
  }
